import React from 'react';
import './styles.scss';

const Separator = () => {
  return <div data-testid="separator" className="separator" />;
};

export default Separator;
